export interface IAgencyEditorData {
  agencyData?: any
  validation?: any
}
export class AgencyEditorData implements IAgencyEditorData {

  agencyData?: any
  validation?: any

  constructor() {
    this.agencyData = undefined;
    this.validation = undefined;
  }
}
